import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../config/withDirection';

const CampaignWrapper = styled.div`


    
`;
export default WithDirection(CampaignWrapper);


// WEBPACK FOOTER //
// ./src/containers/AddCampaign/style.js